import Button from "./Button";
import CommonModal from "./CommonModal";
import "../styles/CommonModal.css";

const ConfirmModal = ({
  show,
  title = "Confirm",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  variant = "danger",
  hideCancel = false,
}) => {
  return (
    <CommonModal
      show={show}
      title={title}
      onClose={onCancel}
      width="420px"
      footer={
        <>
          {!hideCancel && (
            <Button variant="secondary" onClick={onCancel} text={cancelText} btncls="bg-secondary" />
          )}
          <Button variant={variant} onClick={onConfirm} text={confirmText} />
        </>
      }
    >
      <p className="mb-0">{message}</p>
    </CommonModal>
  );
};

export default ConfirmModal;
